export enum Status {
  Ativo = 'true',
  Inativo = 'false',
}

export enum InputType {
  Select = 'SELECT',
  TextEditor = 'EDITOR',
  Radio = 'RADIO',
  Number = 'NUMERO',
  Text = 'TEXTO',
  Data = 'DATA',
}

export enum AnexoType {
  ASO = 1,
  Assinatura_Medico = 2,
  Assinatura_Paciente = 3,
  Telekit = 4,
  Prescricao_Memed = 5,
  Exame = 6,
  Procedimento = 7,
  Informacao = 8,
  Camera = 9,
  Otoscopio = 10,
  Inspecao = 11,
  Assinatura_Profissional = 12,
  Formulario_Atendimento = 13,
  Previa_Formulario = 14,
  Prescricao = 15,
  Prescricao_Especial = 16,
  Ausculta = 17,
  Imagem = 18,
  Formulario_LME = 19,
  Formulario_APAC = 20,
}

export enum Permission {
  Employee = 'EMPLOYEE',
  Usuario = 'USER',
  Admin = 'ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
  SuperMedico = 'SUPER_MEDICO',
  SuperGerente = 'SUPER_GERENTE',
  Medico = 'MEDICO',
  /** Só o ciclo da interconsulta e o cadastro de paciente; nenhuma permissão `Atendimento:*`. */
  Solicitante = 'SOLICITANTE',
}

export enum FormularioSituacao {
  Iniciado = 'INICIADO',
  Respondido = 'RESPONDIDO',
  Cancelado = 'CANCELADO',
  Gerado = 'GERADO',
  Assinado = 'ASSINADO',
  Finalizado = 'FINALIZADO',
}

export enum DocumentoType {
  Cpf = 'CPF',
  Cnpj = 'CNPJ',
  Caepf = 'CAEPF',
}

export enum FatorRiscoType {
  Fisico = 'FISICO',
  Quimico = 'QUIMICO',
  Biologico = 'BIOLOGICO',
  Ergonomico = 'ERGONOMICO',
  Acidente = 'ACIDENTE',
  Psicossocial = 'PSICOSSOCIAL',
  Sem_Risco = 'SEM_RISCO',
}

export enum CargoType {
  Administrador = 'ADMINISTRADOR',
  Colaborador = 'COLABORADOR',
  Gestor_Agenda = 'GESTOR_AGENDA',
  Gestor_Local = 'GESTOR_LOCAL',
  Medico = 'MEDICO',
  Responsavel = 'RESPONSAVEL',
  Solicitante = 'SOLICITANTE',
}

export enum AtendimentoType {
  Assistencial = 'PA',
  Ocupacional = 'ASO',
  Especialista = 'CA',
  Screening = 'SC',
  Telekit = 'TK',
  Interconsulta = 'IC',
}

export enum ResumoAtendimentoType {
  PA = 'Assistencial',
  ASO = 'Ocupacional',
  CA = 'Especialista',
  SC = 'Screening',
  TK = 'O que singifica',
}

export enum AtendimentoEstado {
  Aguardando = 1,
  EmAtendimento = 2,
  Finalizado = 3,
  Falta = 4,
  Cancelado = 5,
  RetornoPendencia = 6,
  Pendente = 7,
}

export enum DispositivoType {
  Balanca = 'BALANCA',
  Oximetro = 'OXIMETRO',
  Termometro = 'TERMOMETRO',
  Pressao = 'PRESSAO',
  Camera = 'CAMERA',
  Otoscopio = 'OTOSCOPIO',
  Inspecao = 'INSPECAO',
  Glicosimetro = 'GLICOSIMETRO',
  Oftalmoscopio = 'OFTALMOSCOPIO',
  Retinografo = 'RETINOGRAFO',
  Estetoscopio = 'ESTETOSCOPIO',
  Dermatoscopio = 'DERMATOSCOPIO',
  Doppler = 'DOPPLER',
  Ecg = 'ECG',
}

export enum AsoType {
  Periodico = 'PERIODICO',
  Admissiona = 'ADMISSIONAL',
  Demissional = 'DEMISSIONAL',
  Funcao = 'FUNCAO',
  Risco = 'RISCO',
  Retorno = 'RETORNO',
  Monitoracao = 'MONITORACAO',
}

export enum SituacaoAso {
  Iniciado = 'INICIADO',
  Atendido = 'ATENDIDO',
  Falta = 'FALTA',
  Gerado = 'GERADO',
  Finalizado = 'FINALIZADO',
  Cancelado = 'CANCELADO',
}

/** Situação da interconsulta do ponto de vista do solicitante (catálogo em /tipos/interconsulta/situacao). */
export enum SituacaoInterconsulta {
  Aguardando = 'AGUARDANDO',
  EmAndamento = 'EM_ANDAMENTO',
  Pendente = 'PENDENTE',
  EmReplica = 'EM_REPLICA',
  Concluida = 'CONCLUIDA',
  Avaliada = 'AVALIADA',
  Cancelada = 'CANCELADA',
}

export enum DuvidaResolvida {
  Sim = 'SIM',
  Parcialmente = 'PARCIALMENTE',
  Nao = 'NAO',
}

export enum ResultadoType {
  Apto = 'APTO',
  AptoComRestricao = 'APTO_COM_RESTRICAO',
  Inapto = 'INAPTO',
  InaptoTemporario = 'INAPTO_TEMPORARIO',
}

export enum GenderType {
  Masculino = 'MASCULINO',
  Feminino = 'FEMININO',
}

export enum LogAtendimentoType {
  Criacao = 'CRIACAO',
  Estado = 'ESTADO',
  Presenca = 'PRESENCA',
  Whereby = 'WHEREBY',
}

export enum NPSType {
  Promotores = 'Promotores',
  Neutros = 'Neutros',
  Detratores = 'Detratores',
}

export enum AnotacaoType {
  Anamnese = 'ANAMNESE',
  Avaliacao = 'AVALIACAO',
  Diagnostico = 'DIAGNOSTICO',
  Terapia = 'TERAPIA',
  Observacao = 'OBSERVACAO',
  Parecer = 'PARECER',
  Pendencia = 'PENDENCIA',
  Replica = 'REPLICA',
  LME_Anamnese = 'LME_ANAMNESE',
  LME_Tratamento = 'LME_TRATAMENTO',
  APAC_Anamnese = 'APAC_ANAMNESE',
}

export enum PrescricaoType {
  Exame = 'EXAME',
  Formula = 'FORMULA',
  Medicamento = 'MEDICAMENTO',
  Especial = 'ESPECIAL',
  /** Notificação de Receita (A, B, B2, retinoides): documento próprio da Anvisa, um medicamento cada. */
  Notificacao = 'NOTIFICACAO',
  /** Antimicrobianos (RDC 471): documento próprio no formulário da Anvisa, numerado como RET. */
  Retencao = 'RETENCAO',
  Orientacoes = 'ORIENTACOES',
  Atestado = 'ATESTADO',
}

/**
 * Tipos de receita numerados pelo SNCR (Anvisa) nesta plataforma; valores iguais aos da API.
 * RCE/RET vêm em blocos de 1.000; as notificações (NR*) em números avulsos. Talidomida fica fora.
 */
export enum TipoReceitaSncr {
  RCE = 'RCE',
  RET = 'RET',
  NRA = 'NRA',
  NRB = 'NRB',
  NRB2 = 'NRB2',
  NRR = 'NRR',
}

/** Receituário que um medicamento exige (Portaria 344/98); valores iguais aos da API. */
export enum Receituario {
  Simples = 'SIMPLES',
  RCE = 'RCE',
  RET = 'RET',
  NRA = 'NRA',
  NRB = 'NRB',
  NRB2 = 'NRB2',
  NRR = 'NRR',
  /** Talidomida: classifica o catálogo, mas a plataforma ainda não emite o documento dela. */
  NRT = 'NRT',
}

export enum PrescricaoSituation {
  Rascunho = 'RASCUNHO',
  Gerada = 'GERADA',
  Assinada = 'ASSINADA',
  Cancelada = 'CANCELADA',
  Finalizada = 'FINALIZADA',
}

export enum EnvioType {
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP',
  Ambos = 'AMBOS',
}

export enum NotificacaoType {
  Email = 'EMAIL',
  Whatsapp = 'WHATSAPP',
  Ambos = 'AMBOS',
}

export enum TarjaType {
  Vermelha = 'Tarja Vermelha',
  Preta = 'Tarja Preta',
  SemTarja = 'Tarja Sem Tarja',
  VermelhaSobRestricao = 'Tarja Vermelha sob restrição',
}

export enum ContratoType {
  Telekit = 'TELEKIT',
  Corpo_Medico = 'MEDICOS',
  Link_Plataforma = 'LINK_PLATAFORMA',
  Link_Celular = 'LINK_CELULAR',
  Retorno = 'RETORNO',
  Clientes_Contratos = 'CLIENTES',
  Layout = 'LAYOUT',
}

export enum RevisionType {
  Unknown = 'UNKNOWN',
  Insert = 'INSERT',
  Update = 'UPDATE',
  Delete = 'DELETE',
}

export enum DocumentoPessoaType {
  Cpf = 'CPF',
  Cns = 'CNS',
  Rg = 'RG',
  Ctps = 'CTPS',
  Passaporte = 'PASSAPORT',
  BilheteIdentidadeAngola = 'BIA',
}

export enum ParametroType {
  Integer = 'INTEGER',
  Number = 'NUMBER',
  String = 'STRING',
  Date = 'DATE',
  Time = 'TIME',
  Especialidade = 'ESPECIALIDADE',
}

export enum ModalidadeType {
  Telekit = 'TELEKIT',
  Presencial = 'PRESENCIAL',
  Remoto = 'REMOTO',
  Parecer = 'PARECER',
}

export enum AssinaturaType {
  A1 = 'A1',
  A3_Nuvem = 'A3_NUVEM',
}

export enum VinculoType {
  Lauduz = 'LAUDUZ',
  Cliente = 'CLIENTE',
}

export enum RacaType {
  Preto = 'PRETO',
  Pardo = 'PARDO',
  Branco = 'BRANCO',
  Amarelo = 'AMARELO',
  Indigena = 'INDIGENA',
  Nao_Informado = 'NAO_INFORMADO',
}

export enum GeneroType {
  Cisgenero = 'CISGENERO',
  Transgenero = 'TRANSGENERO',
  Nao_Binario = 'NAO_BINARIO',
  Neutro = 'NEUTRO',
  Fluido_Agenero = 'FLUIDO_AGENERO',
  Nao_Informado = 'NAO_INFORMADO',
}

export enum PlataformaType {
  Site = 'SITE',
  App = 'APP',
  Api = 'API',
  Telekit = 'TELEKIT',
  Public = 'PUBLIC',
  Upload = 'UPLOAD',
}

export enum Month {
  January = 'JANUARY',
  February = 'FEBRUARY',
  March = 'MARCH',
  April = 'APRIL',
  May = 'MAY',
  June = 'JUNE',
  July = 'JULY',
  August = 'AUGUST',
  September = 'SEPTEMBER',
  October = 'OCTOBER',
  November = 'NOVEMBER',
  December = 'DECEMBER',
}

export enum SituacaoFatura {
  Gerada = 'GERADA',
  Cancelada = 'CANCELADA',
  Autorizada = 'AUTORIZADA',
  Paga = 'PAGA',
}

export enum SituacaoNota {
  Analise = 'ANALISE',
  Cancelada = 'CANCELADA',
  Processamento = 'PROCESSAMENTO',
  Aguardando_Nota = 'AGUARDANDO_NOTA',
  Nota_Recebida = 'NOTA_RECEBIDA',
  Aguardando_Pagamento = 'AGUARDANDO_PAGAMENTO',
  Paga = 'PAGA',
}

export enum StatusType {
  Valido = 'VALIDO',
  Invalido = 'INVALIDO',
  Nao_Encontrado = 'NAO_ENCONTRADO',
}

/**
 * Motivo de não realização de atendimento.
 *
 * A lista de motivos **não mora mais aqui**: ela vem do catálogo do backend
 * (`GET /public/paciente/motivos-nao-realizacao`, via `getMotivosNaoRealizacao`), que é a fonte
 * única da taxonomia — manter uma cópia local criava duas verdades que divergiam.
 *
 * Só permanece o código de "Outros", porque as validações de formulário precisam saber quando o
 * detalhamento livre passa a ser obrigatório. O valor é o identificador trafegado na API (o
 * `name()` do enum Java), não o rótulo exibido — o rótulo vem do catálogo.
 */
export enum MotivoCancelamentoAtendimentoType {
  Outros = 'OUTROS',
}

export enum SituacaoDiagnosticoType {
  Sem_Diagnostico = 'SEM_DIAGNOSTICO_FECHADO',
  Em_Investigacao = 'EM_INVESTIGACAO',
  Diagnosticado = 'DIAGNOSTICADO',
}

export enum CategoriaNotificacaoType {
  Geral = 'GERAL',
  Atendimento = 'ATENDIMENTO',
  Financeiro = 'FINANCEIRO',
  Sistema = 'SISTEMA',
}

export enum TipoReferenciaNotificacaoType {
  NotaVersao = 'NOTA_VERSAO',
}

export enum SituacaoGravacaoType {
  Solicitada = 'SOLICITADA',
  Gravando = 'GRAVANDO',
  Encerrando = 'ENCERRANDO',
  Disponivel = 'DISPONIVEL',
  Erro = 'ERRO',
}

export enum SituacaoTranscricaoType {
  Transcrevendo = 'TRANSCREVENDO',
  Processando = 'PROCESSANDO',
  Concluida = 'CONCLUIDA',
  Erro = 'ERRO',
}

export enum SegmentoNotificacaoType {
  Lista = 'LISTA',
  Atributo = 'ATRIBUTO',
  Fatura_Aguardando_Nota = 'FATURA_AGUARDANDO_NOTA',
  Atendimento_Aberto = 'ATENDIMENTO_ABERTO',
}

export enum CriterioAtendimentoType {
  Nao_Encerrado = 'NAO_ENCERRADO',
  Com_Pendencia = 'COM_PENDENCIA',
}
